<div class="modal-body text-center p-2 pt-10">
  <span
    class="btn btn-icon btn-sm btn-active-light-primary position-absolute top-0 end-0" aria-label="Close"
    (click)="closeModal()"
    inlineSVG="./assets/media/icons/duotune/arrows/arr011.svg"
  ></span>
  <img
    [src]="imageId | appImageUrl"
    alt="Loading..."
    class="image"
  />
</div>
